import * as React from "react";
import { useLocation } from 'react-router';
import IScreenContextType from "src/models/interfaces/IScreenContextType";
import { ProviderPropsTypes } from "src/models/types/ProviderPropsTypes";

/**
 * @description Contexto de bloqueo de pantalla.
 * @constant {React.createContext<IScreenContextType>}
 */
const ScreenContext = React.createContext<IScreenContextType>({} as IScreenContextType);

/**
 * @function ScreenProvider
 * @description Provider bloqueo/desbloqueo de pantallas.
 * @param {React.ReactNode} children
 * @returns {React.FC<ProviderPropsTypes>}
 */
export const ScreenProvider: React.FC<ProviderPropsTypes> = ({ children }: ProviderPropsTypes) => {
    const [lockScreen, setLockScreen] = React.useState<boolean>(false);

    const location = useLocation();

    React.useEffect(() => {
        if (lockScreen) setLockScreen(false);
    }, [location.pathname]);

    return (
    <ScreenContext.Provider value={{ lockScreen, setLockScreen }}>
        {children}
    </ScreenContext.Provider>
    );
}

/**
 * @function ScreenTContext
 * @description Retorna el contexto para bloquear/desbloquear pantalla.
 * @returns {IScreenContextType}
 * @example const { lockScreen, setLockScreen } = ScreenTContext();
 */
export default function ScreenTContext(): IScreenContextType {
    return React.useContext(ScreenContext);
}
